<template>
  <div class="personal-account">
    <div class="coin-record-tabs">
      <span
        v-if="isShowCoinHistory"
        :class="{ active: isActive === 1 }"
        @click="isActive = 1"
      >
        <svg
          class="icon"
          aria-hidden="true"
          style="margin-right: 5px"
        >
          <use xlink:href="#iconjinbi" />
        </svg>
        金幣
      </span>
      <span
        v-if="isShowDiamondHistory && isShowCoinHistory"
        class="line"
      />
      <span
        v-if="isShowDiamondHistory"
        :class="{ active: isActive === 2 }"
        @click="isActive = 2"
      >
        <svg
          class="icon"
          aria-hidden="true"
          style="margin-right: 5px"
        >
          <use xlink:href="#iconzuanshi" />
        </svg>
        鑽石
      </span>
    </div>
    <div class="tab-content">
      <!-- 金幣 -->
      <div
        v-show="isActive === 1"
        class="coin"
      >
        <!-- 查詢 -->
        <div class="search-condition">
          <span class="coin-num">個人金幣數量：{{ currentCoin }}</span>
          <el-select
            v-model="recordType"
            placeholder="記錄類型"
          >
            <el-option
              v-for="item in recordTypeOptions"
              :key="item.dictionaryNameWithCulture"
              :label="item.dictionaryNameWithCulture"
              :value="item.dictionaryValue"
            />
          </el-select>
          <!-- <el-input v-model="operator" placeholder="操作人" suffix-icon="el-icon-search"></el-input> -->
          <span class="gap">時間：</span>
          <el-date-picker
            v-model="startDate"
            align="right"
            type="date"
            placeholder="選擇日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
            @change="pickDate"
          />
          <span class="gap">—</span>
          <el-date-picker
            v-model="endDate"
            align="right"
            type="date"
            placeholder="選擇日期"
            :picker-options="endDatePickerOptions"
            value-format="timestamp"
            @change="pickDateEnd"
          />
          <el-button
            type="danger"
            class="ml-25"
            @click="search"
          >
            搜尋
          </el-button>
          <el-button
            type="info"
            @click="reset"
          >
            重置
          </el-button>
          <el-button
            type="info"
            @click="downloadExl"
          >
            導出
          </el-button>
        </div>
        <!-- 表格 -->
        <div class="table-contain">
          <el-table
            v-loading="loading"
            :data="tableData"
            empty-text="暫無數據"
            style="width: 100%"
          >
            <!-- <el-table-column prop="createTime" label="編號"></el-table-column> -->
            <el-table-column label="時間">
              <template slot-scope="scope">
                {{ scope.row.createTime | initTime | getTime }}
                {{ scope.row.createTime | initTime | getDateTime }}
                <!-- {{scope.row.createTime}} -->
              </template>
            </el-table-column>
            <el-table-column
              prop="userCoinRecordWithCulture"
              label="類型"
            />
            <el-table-column
              prop="sourceName"
              label="轉出組別/人"
            >
              <template slot-scope="scope">
                {{ scope.row.sourceName.trim().length === 0 ? '-' : scope.row.sourceName }}
              </template>
            </el-table-column>
            <el-table-column
              prop="receiveName"
              label="轉入組別/人"
            >
              <template slot-scope="scope">
                {{ scope.row.receiveName.trim().length === 0 ? '-' : scope.row.receiveName }}
              </template>
            </el-table-column>
            <el-table-column
              prop="propertyCoin"
              label="金幣"
            >
              <template slot-scope="scope">
                <span :class="[scope.row.userCoinRecord === 0 || scope.row.userCoinRecord === 3? 'green' : 'red']">{{ scope.row.userCoinRecord | addSymbol }}{{ scope.row.propertyCoin }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="備註"
            >
              <template slot-scope="scope">
                {{ scope.row.remark ? scope.row.remark : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="operatorName"
              label="操作人"
            />
          </el-table>
          <div class="pagination clearfix">
            <div
              v-if="false"
              class="count"
            >
              <span>當前查詢記錄：{{ total }}</span>
              <span>總記錄：{{ totalCount }}</span>
            </div>
            <el-pagination
              background
              :current-page.sync="currentPage"
              :page-size="pageCount"
              :page-sizes="[10, 20, 50, 100]"
              layout="total,sizes, prev, pager,next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
      <!-- 磚石 -->
      <div
        v-show="isActive === 2"
        class="diamond"
      >
        <!-- 查詢 -->
        <div class="search-condition">
          <span class="diamond-num"> 個人鑽石數量：{{ currentDiamond }}</span>
          <!-- <span class="coin-num">個人金幣數量：{{ currentCoin }}</span> -->
          <el-select
            v-model="recordType"
            placeholder="記錄類型"
          >
            <el-option
              v-for="item in recordTypeOptions"
              :key="item.dictionaryNameWithCulture"
              :label="item.dictionaryNameWithCulture"
              :value="item.dictionaryValue"
            />
          </el-select>
          <!-- <el-input v-model="operator" placeholder="操作人" suffix-icon="el-icon-search"></el-input> -->
          <span class="gap">時間：</span>
          <el-date-picker
            v-model="startDate"
            align="right"
            type="date"
            placeholder="選擇日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
            @change="pickDate"
          />
          <span class="gap">—</span>
          <el-date-picker
            v-model="endDate"
            align="right"
            type="date"
            placeholder="選擇日期"
            :picker-options="endDatePickerOptions"
            value-format="timestamp"
            @change="pickDateEnd"
          />
          <el-button
            type="danger"
            class="ml-25"
            @click="searchDiamond"
          >
            搜尋
          </el-button>
          <el-button
            type="info"
            @click="resetDiamond"
          >
            重置
          </el-button>
          <el-button
            type="info"
            @click="downloadExl"
          >
            導出
          </el-button>
        </div>
        <!-- 表格 -->
        <div class="table-contain">
          <el-table
            v-loading="daimondLoading"
            :data="diamondTableData"
            empty-text="暫無數據"
            style="width: 100%"
          >
            <!-- <el-table-column prop="createTime" label="編號"></el-table-column> -->
            <el-table-column label="時間">
              <template slot-scope="scope">
                {{ scope.row.createTime | initTime | getTime }}
                {{ scope.row.createTime | initTime | getDateTime }}
                <!-- {{scope.row.createTime}} -->
              </template>
            </el-table-column>
            <el-table-column
              prop="userCoinRecordWithCulture"
              label="類型"
            />
            <el-table-column
              prop="sourceName"
              label="轉出組別/人"
            >
              <template slot-scope="scope">
                {{ scope.row.sourceName.trim().length === 0 ? '-' : scope.row.sourceName }}
              </template>
            </el-table-column>
            <el-table-column
              prop="receiveName"
              label="轉入組別/人"
            >
              <template slot-scope="scope">
                {{ scope.row.receiveName.trim().length === 0 ? '-' : scope.row.receiveName }}
              </template>
            </el-table-column>
            <el-table-column
              prop="propertyCoin"
              label="鑽石"
            >
              <template slot-scope="scope">
                <span :class="[scope.row.userCoinRecord === 0 || scope.row.userCoinRecord === 3 ? 'green' : 'red']">{{ scope.row.userCoinRecord | addSymbol }}{{ scope.row.propertyCoin }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="remark"
              label="備註"
            >
              <template slot-scope="scope">
                {{ scope.row.remark ? scope.row.remark : '-' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="operatorName"
              label="操作人"
            />
          </el-table>
          <div class="pagination clearfix">
            <div
              v-if="false"
              class="count"
            >
              <span>當前查詢記錄：{{ disabledTotal }}</span>
              <span>總記錄：{{ totalCount }}</span>
            </div>
            <el-pagination
              background
              :current-page.sync="currentPage"
              :page-size="diamondPageCount"
              :page-sizes="[10, 20, 50, 100]"
              layout="total,sizes, prev, pager,next, jumper"
              :total="diamondTotal"
              @size-change="handleDiamondSizeChange"
              @current-change="handleDiamondCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
    name: 'PersonalRecord',
    filters: {
        initTime(t) {
            let time = t.split(/[-T:]/);
            let [year, month, day, hours = 0, minutes = 0, seconds = 0] = time;
            let currentTime = new Date(year, month - 1, day, hours, minutes, seconds);
            return Math.round(currentTime.getTime() / 1000);
        },
        addSymbol(val) {
            if (val === 1 || val === 2 || val === 4 || val === 5) {return '-';}
            if (val === 0 || val === 3) {return '+';}
        }
    },
    data() {
        function getOneMonth() {
            const date = new Date();
            return date.setTime(date.getTime() - 3600 * 1000 * 24 * 31);
        }
        return {
            isUsedDiamond: false,
            isShowDiamondHistory: false,
            isShowCoinHistory: false,
            isActive: 1,
            /* 金币记录 */
            currentCoin: 0,
            loading: false,
            recordType: '',
            recordTypeOptions: [
                {
                    label: '被分配金幣',
                    value: 'organizationToUser'
                },
                {
                    label: '被回收金幣',
                    value: 'userToOrganization'
                },
                {
                    label: '刊登樓盤',
                    value: 'property'
                }
            ],
            // operator: "",
            // startDate: getOneMonth(),
            // startDate: new Date(new Date().setHours(0, 0, 0, 0)),
            startDate: '',
            endDate: new Date().getTime(),
            pickerOptions: {
                disabledDate: time => {
                    if (this.endDate) {
                        return time.getTime() > this.endDate;
                    } 
                        return time.getTime() > new Date().getTime();
                    
                }
            },
            endDatePickerOptions: {
                disabledDate: time => {
                    if (this.startDate) {
                        return time.getTime() < this.startDate || time.getTime() > new Date().getTime();
                    } 
                        return time.getTime() > new Date().getTime();
                    
                }
            },
            tableData: [],
            total: 0, //当前查询记录
            totalCount: 0, // 总记录
            pageIndex: 1,
            pageCount: 10,
            currentPage: 1,
            /* 砖石记录 */
            daimondLoading: false,
            currentDiamond: 0,
            diamondTableData: [],
            diamondTotal: 0,
            daimondPageIndex: 1,
            diamondPageCount: 10
        };
    },
    watch: {
        isActive(val) {
            /* 重置数据 */
            this.recordType = '';
            // this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            // this.startDate.setDate(this.startDate.getDate()- 29)
            this.startDate.setDate(this.startDate.getDate() - 364);

            this.endDate = new Date().getTime();
            if (val === 1) {
                this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'percoinRePageCount') || 10;
                /* 金币 */
                this.pageIndex = 1;
                this.searchUserCoinRecord();
            } else {
                this.diamondPageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'perdiaRePageCount') || 10;
                /* 砖石 */
                this.daimondPageIndex = 1;
                this.searchUserDiamondRecord();
            }
        }
    },
    created() {
        // debugger
        this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
        // this.startDate.setDate(this.startDate.getDate()- 29)
        this.startDate.setDate(this.startDate.getDate() - 364);
        this.getCompanyCofig();
        this.pageCount = this.pub.getPageSize(this.$store.state.userInfo.accountID, 'percoinRePageCount') || 10;
        this.searchUserCoinRecord();
        this.getRecordTypes();
    },
    methods: {
        addSymbols(val) {
            if (val === 1 || val === 2 || val === 4  || val === 5) {return '-';}
            if (val === 0 || val === 3) {return '+';}
        },
        async downloadExl(data = {}) {
            const loading = this.$loading({
                lock: true,
                text: '正在努力導出數據,大約會耗時幾分鐘，請不要關閉當前網頁',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            //金币
            if (this.isActive == 1) {
                let res = await this.axios.post(
                    this.pub.getApi().SearchUserCoinRecord,
                    Object.assign(
                        {
                            pageIndex: 1,
                            pageCount: 50000,
                            startTime: this.startDate / 1000,
                            endTime: this.endDate / 1000
                        },
                        data
                    )
                );
                let { code, result } = res.data;
                if (code === 0) {
                    this.tableDatas = result.record.data;
                }
            }
            //钻石
            if (this.isActive == 2) {
                let res = await this.axios.post(
                    this.pub.getApi().SearchUserDiamondRecord,
                    Object.assign(
                        {
                            pageIndex: 1,
                            pageCount: 50000,
                            startTime: this.startDate / 1000,
                            endTime: this.endDate / 1000
                        },
                        data
                    )
                );
                let { code, result } = res.data;
                if (code === 0) {
                    this.tableDatas = result.record.data;
                }
            }
            if (!this.tableDatas) {return;}
            const arr = [];
            let header = {}
            // console.log('this.tableDatas', this.tableDatas);
            if (this.isActive == 1) {
                this.tableDatas.forEach(item => {
                    let a = this.addSymbols(item.userCoinRecord);
                    let obj = {};
                    obj.時間 = item.createTimeStr;
                    obj.類型 = item.userCoinRecordWithCulture;
                    // obj.轉出組別= item.sourceName;
                    // obj.轉入組別 = item.receiveName;
                    obj['轉出組別/人'] = item.sourceName;
                    obj['轉入組別/人'] = item.receiveName;
                    if (a == '-') {
                        obj.金幣 = parseInt(`${a}${item.propertyCoin}`);
                    } else {
                        obj.金幣 = parseInt(item.propertyCoin);
                    }
                    obj.操作人 = item.operatorName;
                    obj.備註 = item.remark;
                    arr.push(obj);
                });
                header = { header: ['時間', '類型', '轉出組別/人', '轉入組別/人', '備註', '金幣', '操作人'] };
            } else {
                this.tableDatas.forEach(item => {
                    let a = this.addSymbols(item.userCoinRecord);
                    let obj = {};
                    obj.時間 = item.createTimeStr;
                    obj.類型 = item.userCoinRecordWithCulture;
                    obj['轉出組別/人'] = item.sourceName;
                    obj['轉入組別/人'] = item.receiveName;
                    if (a == '-') {
                        obj.鑽石 = parseInt(`${a}${item.propertyCoin}`);
                    } else {
                        obj.鑽石 = parseInt(item.propertyCoin);
                    }
                    // obj.鑽石 = parseInt(`${a}${item.propertyCoin}`);
                    obj.操作人 = item.operatorName;
                    obj.備註 = item.remark;
                    arr.push(obj);
                });
                header = { header: ['時間', '類型', '轉出組別/人', '轉入組別/人', '備註', '鑽石', '操作人'] };
            }
            const ws = XLSX.utils.json_to_sheet(arr, header);
            const wb = XLSX.utils.book_new();
            if (this.isActive == 1) {
                XLSX.utils.book_append_sheet(wb, ws, 'PMS金幣記錄');
                XLSX.writeFile(wb, 'PMS金幣記錄.xlsx');
            } else {
                XLSX.utils.book_append_sheet(wb, ws, 'PMS鑽石記錄');
                XLSX.writeFile(wb, 'PMS鑽石記錄.xlsx');
            }
            // XLSX.utils.book_append_sheet(wb, ws, '数据');
            // XLSX.writeFile(wb, '数据.xlsx');
            loading.close();
        },
        // 获取公司配置
        getCompanyCofig() {
            this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
                // console.log(res,'配置');
                if (res.data.code === 0 && res.data.result) {
                    // 1 中原，2 利嘉阁 3 其他公司
                    // this.isProhibitBuyCoin = res.data.result.isProhibitBuyCoin;
                    this.isUsedDiamond = res.data.result.isUsedDiamond;
                    this.isShowDiamondHistory = res.data.result.isShowDiamondHistory;
                    this.isShowCoinHistory = res.data.result.isShowCoinHistory;
                    // 判断其是否启用钻石或者金币
                    if (!(this.isShowDiamondHistory && this.isShowCoinHistory) && this.isShowDiamondHistory) {
                        setInterval(() => {
                            this.isActive = 2;
                        }, 300);
                    }
                }
            });
        },
        /* 獲取記錄類型 */
        async getRecordTypes() {
            let res = await this.axios.get(this.pub.getApi().SearchDictionaryInfo);
            if (res.data.code === 0 && res.data.result) {
                //   console.log(res.data.result,'字典數據')
                res.data.result.forEach(ele => {
                    if (ele.itemName === 'OrganizationCoinTrans') {
                        //   console.log(ele,'組別')
                        //   this.organizationTypeOptions = this.handleRecordType(ele)
                        //   console.log(this.handleRecordType(ele))
                    }
                    if (ele.itemName === 'UserCoinRecord') {
                        this.recordTypeOptions = this.handleRecordType(ele).filter(item => {
                            return item.dictionaryNameWithCulture != '全部收入' && item.dictionaryNameWithCulture != '全部支出';
                        });
                        //   console.log(ele,'個人')
                    }
                });
            }
        },
        /* 類型數據處理 */
        handleRecordType(obj) {
            let data = [];
            if (obj.children && obj.children.length > 0) {
                obj.children.forEach(item => {
                    let result = this.handleRecordType(item);
                    data = data.concat(result);
                });
            } else {
                data = data.concat(obj);
            }
            return data;
        },
        async searchUserCoinRecord(data = {}) {
            this.loading = true;
            let res = await this.axios.post(
                this.pub.getApi().SearchUserCoinRecord,
                Object.assign(
                    {
                        pageIndex: this.pageIndex,
                        pageCount: this.pageCount,
                        startTime: this.startDate / 1000,
                        endTime: this.endDate / 1000
                        // endTime: this.startDate === this.endDate ? this.endDate / 1000 + 86399 : this.endDate / 1000
                    },
                    data
                )
            );
            this.loading = false;
            // console.log("userRecord", res);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.total = result.record.count;
                this.tableData = result.record.data;
                this.currentCoin = result.currentCoin;
                if (Object.keys(data).length === 0) {
                    this.totalCount = result.record.count;
                }
            }
        },
        search() {
            if (!this.endDate || !this.startDate) {
                this.$message({
                    message: '請選擇日期',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            let tewMonth = 3600 * 1000 * 24 * 30 * 12 + 5 * 3600 * 1000 * 24;
            // console.log("??????",this.endDate - this.startDate,"x",this.endDate,"g",this.startDate,sixMonth)
            if (this.endDate - this.startDate > tewMonth) {
                this.$message({
                    message: '最長週期為365天',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            this.pageIndex = 1;
            this.currentPage = 1;

            let data = {};
            if (this.recordType) {
                data.userCoinRecord = this.recordType;
            }
            this.searchUserCoinRecord(data);
        },
        reset() {
            this.recordType = '';
            // this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            // this.startDate.setDate(this.startDate.getDate()-29)
            this.startDate.setDate(this.startDate.getDate() - 364);

            this.endDate = new Date().getTime();
            this.pageIndex = 1;
            this.searchUserCoinRecord();
        },
        handleSizeChange(val) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID,'percoinRePageCount',val) 
            this.pageCount = val;
            this.pageIndex = 1;
            let data = {};
            if (this.recordType) {data.recordType = this.recordType;}
            this.searchUserCoinRecord(data);
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            let data = {};
            if (this.recordType) {data.recordType = this.recordType;}
            this.searchUserCoinRecord(data);
        },
        getOneMonth() {
            const date = new Date();
            return date.setTime(date.getTime() - 3600 * 1000 * 24 * 31);
        },
        pickDate(date) {
            // console.log(date);
            if (!date) {return;}
            let tewMonth = 3600 * 1000 * 24 * 30 * 12 + 5 * 3600 * 1000 * 24;
            if (this.endDate - date > tewMonth) {
                this.$message({
                    message: '最長週期為365天',
                    type: 'error',
                    showClose: true
                });
                return;
            }
        },
        pickDateEnd(date) {
            if (!date) {return;}
            let tewMonth = 3600 * 1000 * 24 * 30 * 12 + 5 * 3600 * 1000 * 24;
            if (date - this.startDate > tewMonth) {
                this.$message({
                    message: '最長週期為365天',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            // 只要改变了 所有的endtime 都加时间
            this.endDate = this.endDate + 86399000;
            console.log(this.endDate, 'endDate');
        },
        /* 获取当前人的砖石记录 */
        async searchUserDiamondRecord(data = {}) {
            this.daimondLoading = true;
            let res = await this.axios.post(
                this.pub.getApi().SearchUserDiamondRecord,
                Object.assign(
                    {
                        pageIndex: this.daimondPageIndex,
                        pageCount: this.diamondPageCount,
                        startTime: this.startDate / 1000,
                        endTime: this.endDate / 1000
                    },
                    data
                )
            );
            this.daimondLoading = false;
            // console.log("userRecord", res);
            let { code, result, message } = res.data;
            if (code === 0) {
                this.diamondTotal = result.record.count;
                this.diamondTableData = result.record.data;
                this.currentDiamond = result.currentCoin;
            }
        },
        searchDiamond() {
            if (!this.endDate || !this.startDate) {
                this.$message({
                    message: '請選擇日期',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            let tewMonth = 3600 * 1000 * 24 * 30 * 12 + 5 * 3600 * 1000 * 24;
            if (this.endDate - this.startDate > tewMonth) {
                this.$message({
                    message: '最長週期為365天',
                    type: 'error',
                    showClose: true
                });
                return;
            }
            this.daimondPageIndex = 1;
            this.currentPage = 1;
            let data = {};
            if (this.recordType) {
                data.userCoinRecord = this.recordType;
            }
            this.searchUserDiamondRecord(data);
        },
        resetDiamond() {
            this.recordType = '';
            // this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            this.startDate = new Date(new Date().setHours(0, 0, 0, 0));
            this.startDate.setDate(this.startDate.getDate() - 364);

            this.endDate = new Date().getTime();
            this.daimondPageIndex = 1;
            this.searchUserDiamondRecord();
        },
        handleDiamondSizeChange(val) {
            this.pub.userPageSize(this.$store.state.userInfo.accountID,'perdiaRePageCount',val) 
            this.diamondPageCount = val;
            this.daimondPageIndex = 1;
            let data = {};
            if (this.recordType) {data.recordType = this.recordType;}
            this.searchUserDiamondRecord(data);
        },
        handleDiamondCurrentChange(val) {
            this.daimondPageIndex = val;
            let data = {};
            if (this.recordType) {data.recordType = this.recordType;}
            this.searchUserDiamondRecord(data);
        }
    }
};
</script>
<style lang="less" scoped>
@import '../../../assets/css/element-reset.less';
.personal-account {
    height: 100%;
    .coin-record-tabs {
        margin-bottom: 20px;
        span {
            display: inline-block;
            // margin-right: 60px;
            font-size: 22px;
            color: #92929d;
            letter-spacing: 0.1px;
            cursor: pointer;
        }
        span.active {
            color: #171725;
        }
        .line {
            width: 1px;
            height: 22px;
            background-color: #979797;
            position: relative;
            top: 3px;
            margin: 0 22px;
        }
    }
    .coin-num,
    .diamond-num {
        display: inline-block;
        padding: 0 10px;
        line-height: 38px;
        background-color: #fff;
        border-radius: 5px;
        color: #0062ff;
        margin-right: 15px;
        border-radius: 10px;
    }
    // 查詢條件
    .search-condition {
        border-bottom: 1px solid #e2e2ea;
        padding-bottom: 30px;
        .el-select {
            width: 120px;
            margin-right: 15px;
            margin-top: 10px;
            /deep/.el-input__inner {
                background: #ffffff;
                border-radius: 10px;
                border: none;
                height: 38px;
                line-height: 38px;
            }
        }
        .el-input {
            width: 150px;
            /deep/.el-input__inner {
                background: #ffffff;
                border-radius: 10px;
                border: none;
                height: 38px;
                line-height: 38px;
            }
        }
        .el-input + .el-input {
            margin-right: 15px;
            margin-top: 10px;
        }
        // .el-input + span {
        //   margin-right: 5px;
        //   margin-left: 5px;
        // }
        .gap {
            margin-right: 5px;
            margin-left: 5px;
        }
        .el-button {
            width: 88px;
            margin-left: 10px;
            margin-top: 10px;
            border-radius: 10px;
        }
        .ml-25 {
            margin-left: 25px;
        }
    }
    // 數據列表
    .table-contain {
        border-radius: 10px;
        padding: 15px 10px;
        background-color: #fff;
        margin-top: 20px;
        .pagination {
            // text-align: center;
            margin-top: 20px;
            line-height: 35px;
            .count {
                float: left;
                span ~ span {
                    margin-left: 10px;
                }
            }
            .el-pagination {
                float: right;
            }
        }
    }
    // .diamond {
    //     .diamond-num {
    //         color: #000;
    //         font-size: 16px;
    //         margin-bottom: 10px;
    //     }
    // }
    .red {
        color: #e50113;
    }
    .green {
        color: green;
    }
    .clearfix:after {
        content: '';
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }
    .clearfix {
        /* 触发 hasLayout */
        zoom: 1;
    }
}
</style>
